import { Box, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { useI18N } from "../../../common/common";

const useStyles = makeStyles((theme) => ({
    legendSectionItem: {
        backgroundColor: theme.palette.grey[50],
        padding: theme.spacing(0.5, 2),

        "&.full": {
            backgroundColor: theme.palette.primary[200]
        },
        "&.half": {
            backgroundColor: theme.palette.background.white,
            background: `linear-gradient(to top left, transparent 50%, ${theme.palette.primary[200]} 50%)`
        }
    },
}));

const AvailabilityCalendarLegendSection = () => {
    const classes = useStyles();
    const {i18n} = useI18N();

    return (
        <>
            <Box className={clsx(classes.legendSectionItem, "full")}>
                <Typography variant="body2">
                    {i18n("common.label.available")}
                </Typography>
            </Box>

            <Box className={clsx(classes.legendSectionItem, "half")}>
                <Typography variant="body2">
                    {i18n("common.label.checkout_only")}
                </Typography>
            </Box>
        </>
    );
};

export default AvailabilityCalendarLegendSection;
